import React from 'react';

interface CircleWithDotProps {
    size?: number;
    strokeWidth?: number;
    circleColor?: string;
    progressColor?: string;
    progress?: number;
}

export const CircleWithDot: React.FC<CircleWithDotProps> = ({
    size = 100,
    strokeWidth = 5,
    circleColor = '#E0E0E0',
    progressColor = '#ffa400',
    progress = 50,
}) => {
    const circleRadius = (size - strokeWidth) / 2;
    const circleCenter = size / 2;
    const circumference = 2 * Math.PI * circleRadius;

    const progressPercentage = Math.min(Math.max(progress, 0), 100);
    const strokeDashoffset = circumference - (circumference * progressPercentage) / 100;

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <circle cx={circleCenter} cy={circleCenter} r={circleRadius} strokeWidth={strokeWidth} stroke={circleColor} fill="none" />
            <circle
                cx={circleCenter}
                cy={circleCenter}
                r={circleRadius}
                strokeWidth={strokeWidth}
                stroke={progressColor}
                fill="none"
                strokeLinecap="round"
                transform={`rotate(-90, ${circleCenter}, ${circleCenter})`}
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
            />
        </svg>
    );
};
